<template>
  <div class="box">
    <!-- 职位展示 -->
    <div class="Service-body firm-clickable" v-for="(item, index) in listArr" :key="index" @click="handelComeAndHelp(item)">
      <div class="Select-box" v-if="distinguish==1">
        <el-checkbox v-model="item.choose"></el-checkbox>
      </div>
      <!-- 状态 -->
      <div
        class="status-show"
        :class="
          item.status == '0'
            ? 'CallForBids'
            : item.status == '1'
            ? 'proceed'
            : item.status == '2'
            ? 'examine'
            : item.status == '3'
            ? 'Lose'
            : item.status == '4'
            ? 'delist'
            : item.status == '5'
            ? 'complete'
            : ''
        "
      ></div>
      <!-- 需求名 -->
      <p class="requirement">本公司需要logo设计</p>
      <!-- 价格 -->
      <p class="Price">￥ 2000</p>
      <!-- 需求类型 -->
      <p class="type">需求类型：LOGO设计</p>
      <!-- 需求描述 -->
      <p class="Description-title">需求描述：</p>
      <!-- 描述 -->
      <p class="Description">
        国际物流行业，需求轻微修改logo中英文字体设计，目前原有logo寓意是国际物流面向全球运输yc字母组成环绕地
      </p>
      <!-- 日期  删除按钮 -->
      <div class="bottom">
        <p>2024年12月12日发布</p>
        <div v-if="distinguish==1"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listArr: {},
    distinguish: {}, // 1店铺管理中使用，显示选择框与删除按钮   2是帮帮中使用不显示选择框与删除按钮
  },
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 点击模块
    handelComeAndHelp(item) {
      this.$emit("handelComeAndHelp", item);
    },
  },
};
</script>

<style scoped lang="less">
// 筛选区
.box {
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  color: #666666;
  .Service-body:hover {
    // border: 1px solid #409eff ;
    box-shadow: 0px 0px 5px 0px rgba(97, 144, 232, 1);
  }
  .Service-body {
    padding: 10px;
    width: 250px;
    min-height: 100px;
    font-size: 14px;
    position: relative;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 10px;
    margin-right: 18px;
    margin-bottom: 18px;
    // 选择
    .Select-box {
      width: 15px;
      height: 15px;
      margin: auto 0;
      display: flex;
      /deep/.el-checkbox__inner {
        width: 15px;
        height: 15px;
        border: 1px solid #409eff ;
      }
    }
    // 展示状态
    .status-show {
      width: 45px;
      height: 25px;
      position: absolute;
      top: 0;
      right: 0;
    }

    // 招标中
    .CallForBids {
      background-image: url("../../../../../../assets/imgs/img/geren-SVG/shangjia@3x.svg");
      background-size: 100% 100%;
    }
    // 进行中
    .proceed {
      background-image: url("../../../../../../assets/imgs/jinxingzhong@3x.svg");
      background-size: 100% 100%;
    }
    // 审核
    .examine {
      background-image: url("../../../../../../assets/imgs/shenhezhong@3x.svg");
      background-size: 100% 100%;
    }
    // 审核失败
    .Lose {
      background-image: url("../../../../../../assets/imgs/shenheshibai@3x.svg");
      background-size: 100% 100%;
    }
    // 下架
    .delist {
      background-image: url("../../../../../../assets/imgs/xiajia@3x.svg");
      background-size: 100% 100%;
    }
    //完成
    .complete {
      background-image: url("../../../../../../assets/imgs/yiwancheng@3x.svg");
      background-size: 100% 100%;
    }

    // 需求名
    .requirement {
      width: 100%;
      height: 17px;
      line-height: 17px;
      font-size: 14px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-top: 20px;
    }
    // 价格
    .Price {
      font-size: 16px;
      color: #fe574a;
      margin-top: 10px;
    }
    // 需求类型
    .type {
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 12px;
      margin-top: 20px;
      margin-bottom: 10px;
    }
    .Description-title {
      font-size: 12px;
    }
    .Description {
      width: 100%;
      height: 45px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #666666;
      letter-spacing: 1px;
      text-align: justify;
      line-height: 15px;
      font-weight: 400;
      margin-top: 10px;
      //   white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .bottom {
      width: 100%;
      height: 20px;
      line-height: 20px;
      position: relative;
      margin-top: 20px;
      display: flex;
      p {
        font-size: 12px;
        color: #666666;
      }
      //   删除按钮
      div {
        width: 20px;
        height: 20px;
        background-image: url("../../../../../../assets/imgs/shanchu@3x.svg");
        background-size: 100% 100%;
        position: absolute;
        right: 0;
      }
    }
  }
  .Service-body:nth-child(4) {
    margin-right: 0px;
  }
  .Service-body:nth-child(8) {
    margin-right: 0px;
  }
}
</style>
